__turbopack_context__.v({
  "paginationInfo": "PagePagination-module-scss-module__q_WTCG__paginationInfo",
  "paginationRow": "PagePagination-module-scss-module__q_WTCG__paginationRow",
});
